import { render, staticRenderFns } from "./summary2.vue?vue&type=template&id=67b333e5&scoped=true&"
import script from "./summary2.vue?vue&type=script&lang=js&"
export * from "./summary2.vue?vue&type=script&lang=js&"
import style0 from "./summary2.vue?vue&type=style&index=0&id=67b333e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b333e5",
  null
  
)

export default component.exports